<button (click)="close()"
        class="close icon icon-cross icon-size-16"></button>
<div class="mat-dialog-header">
    <h1>{{'Selectionner mon compte' | transloco}}</h1>
</div>
<mat-dialog-content>
    <div class="content__header">
        <p class="margin-button-50"
           [innerHTML]="'Il existe plusieurs comptes infomaniak avec comme identifiant $name$ ?' | transloco: {name: '<strong>' + (userName | escapeHtml) + '</strong>'}">
        </p>
        <p><strong>{{'Selectionnez le votre et connectez-vous :' | transloco}}</strong></p>
    </div>
    <div class="content__buttons">
        <button class="mat-elevation-z"
                (click)="selectOwner()"
                *ngFor="let user of accountUsers"
                mat-raised-button
                color="accent">
            <p><span class="content__buttons--name">{{ user.name }}</span><span class="content__buttons--info">{{ 'Creation: $date$' | transloco: {date: user.created_at  * 1000 | date:'shortDate':undefined:language} }}</span></p>
            <p><span class="content__buttons--email">{{ user.email }}</span><span class="content__buttons--info">{{ '$num$ produit(s)' | transloco: {num: user.products_count || '0'} }}</span></p>
        </button>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="mat-elevation-z"
            (click)="close()"
            mat-raised-button
            color="accent">
        {{ 'Retour' | transloco }}
    </button>
</mat-dialog-actions>
